import * as Yup from 'yup'

export const MVRManualUploadFormSchema = Yup.object().shape({
  mvrFile: Yup.string().required('Motor vehicle record is required'),
})
